import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { withIDKeys } from '@/utils/state_helpers'
import { useMessagesStore } from '@/stores/messages'

const defaultCurrent = { id: null, path: '' }

export const useCustomFoldersStore = defineStore('customFolders', {
  state: () => ({
    current: { id: null, path: '' },
    customFolders: {}
  }),

  getters: {
    allPaths: ({ customFolders }) => Object.values(customFolders).map((folder) => folder.path),
  },

  actions: {
    resetCurrent() {
      this.current = Object.assign({}, defaultCurrent)
    },

    async fetchForStory(storyId) {
      return httpClient.get(`/api/internal/stories/${storyId}/custom_folders`)
        .then(response => {
          this.customFolders = withIDKeys(response.data.custom_folders)
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async create(storyId) {
      return httpClient.post(`/api/internal/stories/${storyId}/custom_folders`, {
        custom_folder: { path: '' }
      })
      .then(({ data: { custom_folder }}) => {
        this.customFolders[custom_folder.id] = custom_folder
      })
      .catch((err) => {
        useMessagesStore().smartAdd(err)
      })
    },

    async update(customFolderId) {
      return httpClient.patch(`/api/internal/custom_folders/${customFolderId}`, {
        custom_folder: this.customFolders[customFolderId]
      })
        .then(({ data: { custom_folder }}) => {
          this.customFolders[custom_folder.id] = custom_folder
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async delete(customFolderId) {
      return httpClient.delete(`/api/internal/custom_folders/${customFolderId}`)
        .then(() => {
          delete this.customFolders[customFolderId]
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    }
  }
})
